var map = {
	"./calendar.html": 33,
	"./calendarDayView.html": 34,
	"./calendarHourList.html": 35,
	"./calendarMonthCell.html": 36,
	"./calendarMonthCellEvents.html": 37,
	"./calendarMonthView.html": 38,
	"./calendarSlideBox.html": 39,
	"./calendarWeekView.html": 40,
	"./calendarYearView.html": 41
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;



//////////////////
// WEBPACK FOOTER
// ./src/templates nonrecursive \.html
// module id = 10
// module chunks = 0